import Custom from './custom/custom.vue';
import type {
  OfferListBlock,
  OfferListBlockContentItems,
} from '@/interfaces/constructor';
const QuickViewOffer = defineAsyncComponent(
  () => import('~/components/modals/quick-view-offer/quick-view-offer.vue')
);

export default defineComponent({
  name: 'PromoOfferList',
  components: {
    Custom,
    QuickViewOffer,
  },
  props: {
    data: {
      type: Object as () => OfferListBlock,
      required: true,
    },
  },
  emits: ['promo-banner-click'],
  setup(props) {
    const showQuickViewOffer = ref(false);
    function openModal(model: OfferListBlockContentItems) {
      showQuickViewOffer.value = true;
    }

    const isItems = computed(
      () => props.data?.items && props.data.items.length
    );

    const id = computed(() => (isItems.value ? props.data?.id : '0'));

    const isPromoFix = computed(() => !!props.data?.isPromoFix);

    return {
      openModal,
      isItems,
      id,
      isPromoFix,
      showQuickViewOffer,
    };
  },
});
